// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import { ScrollView, StyleSheet, View, Image } from "react-native";
import DataRange from "../../components/Shadows/Farmer/Data/DataRange";
import colors from "../../config/colors";
import DataTable1 from "../../components/Shadows/Farmer/Data/DataTableComponent";
import { fetchSharedStatistics, fetchBathtubsDataPageFilter } from "../../axios/axiosConfig";
import AsyncStorage from "@react-native-async-storage/async-storage";

const DataScreen = ({ getTranslation, language, formatDate }) => {
    const [selectedDateRange, setSelectedDateRange] = useState({});
    const [responseData, setResponseData] = useState(null);
    const [bathtubs, setBathtubs] = useState(null);
    const [selectedBathtub, setSelectedBathtub] = useState(null);
    const [isShared, setIsShared] = useState(false);
    const [direction, setDirection] = useState("IN");

    const handleFilterChange = (startDate, endDate) => {
        setSelectedDateRange({ startDate, endDate });
    };
    async function onChangeFilters(changedData) {
        try {
            let response;
            if (changedData.material == "DigestatoLiquido") {
                response = await fetchSharedStatistics(
                    changedData.startDate,
                    changedData.endDate,
                    changedData.material,
                    changedData.bathtub,
                    changedData.direction
                );
                setDirection(changedData.direction);
            } else {
                response = await fetchSharedStatistics(
                    changedData.startDate,
                    changedData.endDate,
                    changedData.material
                );
            }
            if (response.status === 200) {
                setResponseData(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        AsyncStorage.getItem("userData").then((userData) => {
            const userDataObject = JSON.parse(userData);
            if (userDataObject && (userDataObject.landingView === "Farmer" || userDataObject.landingView === "SharedDepositManager")) {
                fetchTubs(userDataObject.landingView);
            }
        });
    }, []);

    async function fetchTubs(role) {
        if (role == "SharedDepositManager") {
            setIsShared(true);
        }
        try {
            const response = await fetchBathtubsDataPageFilter(role);
            if (response.status === 200) {
                const bathtubsData = response.data;
                setBathtubs(bathtubsData);
                setSelectedBathtub(bathtubsData[0]?.id);
            }
        } catch (error) {
            console.error("Error fetching bathtubs:", error);
        }
    }

    return (
        <>
            <ScrollView style={styles.container}>
                <DataRange
                    onDateRangeChange={handleFilterChange}
                    getTranslation={getTranslation}
                    language={language}
                    onChangeFilters={onChangeFilters}
                    bathtubs={bathtubs}
                    selectedBathtub={selectedBathtub}
                    formatDate={formatDate}
                    setSelectedBathtub={setSelectedBathtub}
                />
                <DataTable1
                    title={getTranslation("Quantità letame e liquame uscito")}
                    dateFrom={selectedDateRange.startDate}
                    dateTo={selectedDateRange.endDate}
                    getTranslation={getTranslation}
                    language={language}
                    shared={isShared}
                    responseData={responseData}
                    formatDate={formatDate}
                    direction={direction}
                />
            </ScrollView>
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 10,
        paddingVertical: 5,
        backgroundColor: colors.green,
    },
});

export default DataScreen;
